import React from 'react'
import { Subtitle } from './RegistrationCard.styles';

interface TOPProps {
  expDate: Date;
}

export const SubTitle = ( { expDate }: TOPProps ) => {
  return (
    <Subtitle>
      Temporary Operating Plate Expiration:&nbsp;
      <span>{expDate.toLocaleString('default', { month: 'short', day: 'numeric', 'year': 'numeric', timeZone: 'UTC'})}</span>
    </Subtitle>
  );
}